import { render, staticRenderFns } from "./CategoriesIndex.vue?vue&type=template&id=fd8f77ec"
import script from "./CategoriesIndex.vue?vue&type=script&lang=js"
export * from "./CategoriesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports